import React from 'react';
import NavbarDropdown from './navbarDropdown';
import { relationsRoutes, proposalsRoutes } from 'routes/siteMaps';
import NavbarDropdownApp from './navbarDropdownApp';

const NavbarTopDropDownMenus = () => {
  return (
    <>
      <NavbarDropdown title="relaties">
        <NavbarDropdownApp items={relationsRoutes.children} />
      </NavbarDropdown>

      <NavbarDropdown title="offertes">
        <NavbarDropdownApp items={proposalsRoutes.children} />
      </NavbarDropdown>
    </>
  );
};

export default NavbarTopDropDownMenus;